import React, { Fragment } from 'react';
import { bool, func, string } from 'prop-types';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import classNames from 'classnames';
import {
  FieldSelect,
  FieldStepperEditable,
  FieldTextInput,
  Form,
  Modal,
  PrimaryButton,
  SecondaryButton,
  TextContainer,
} from '../../components';

import css from './styles.css';
import { Form as FinalForm } from 'react-final-form';
import { required } from '../../util/validators';
import { map } from 'ramda';
import { getDeclineByProviderReasons } from '../../marketplace-custom-config';

const DeclineBookingModal = (props) => {
  const {
    className,
    rootClassName,
    id,
    intl,
    isOpen,
    isHighDeclineRate,
    onOkModal,
    onCloseModal,
    onManageDisableScrolling,
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const closeButtonMessage = intl.formatMessage({ id: 'Actions.cancel' });
  const requiredMessage = intl.formatMessage({ id: 'Marketplace.requiredMessage' });
  const selectPlaceholder = intl.formatMessage({
    id: 'EditListingInformationForm.selectPlaceholder',
  });
  const onSubmit = (values) => {
    const { reason, reasonDetails } = values;
    onOkModal({
      reason,
      reasonDetails,
    });
  };

  const getWarningMessageId = (reason) => {
    switch (reason) {
      case 'lowBookingAmount':
        return 'DeclineBookingModal.warning.lowBookingAmount';
      case 'tenantAskedToCancel':
        return 'DeclineBookingModal.warning.tenantAskedToCancel';
      case 'untrustedProfile':
        return 'DeclineBookingModal.warning.untrustedProfile';
      default:
        return reason ? 'DeclineBookingModal.warning.default' : null;
    }
  };

  return (
    <Modal
      id={id}
      containerClassName={classes}
      contentClassName={css.modalContent}
      isOpen={isOpen}
      onClose={onCloseModal}
      onManageDisableScrolling={onManageDisableScrolling}
      closeButtonMessage={closeButtonMessage}
    >
      <p className={css.modalTitle}>
        <FormattedMessage id="DeclineBookingModal.title" />
      </p>
      <FinalForm
        initialValues={{}}
        onSubmit={(values) => onSubmit(values)}
        render={(formRenderProps) => {
          const { active, form, handleSubmit, values } = formRenderProps;
          const warningMessageId = getWarningMessageId(values.reason);
          const shouldShowWarning = isHighDeclineRate && warningMessageId;
          return (
            <Fragment>
              <Form id="bookingForm" onSubmit={handleSubmit} className={css.reasonForm}>
                <FieldSelect
                  className={css.reasonChoice}
                  id="reason"
                  name="reason"
                  label={intl.formatMessage({ id: 'TransactionPanel.declineReason' })}
                  validate={required(requiredMessage)}
                >
                  <option value="">{selectPlaceholder}</option>
                  {map(
                    ({ label, key }) => (
                      <option key={key} value={key}>
                        {label}
                      </option>
                    ),
                    getDeclineByProviderReasons(intl)
                  )}
                </FieldSelect>
                {values.reason === 'other' && (
                  <FieldTextInput
                    id="reasonDetails"
                    name="reasonDetails"
                    validate={required(requiredMessage)}
                    type="textarea"
                    label={intl.formatMessage({ id: 'TransactionPanel.cancelReasonDetails' })}
                    placeholder="..."
                  />
                )}
                {shouldShowWarning ? (
                  <TextContainer
                    className={css.warningMessage}
                    text={intl.formatMessage({ id: warningMessageId })}
                  />
                ) : null}
                <SecondaryButton className={css.modalButtonOk} type={'submit'}>
                  <FormattedMessage id="TransactionPanel.confirm" />
                </SecondaryButton>
              </Form>
            </Fragment>
          );
        }}
      />
      {/*<SecondaryButton className={css.modalButtonOk} onClick={onOkModal}>*/}
      {/*  <FormattedMessage id="TransactionPanel.confirmCancelation" />*/}
      {/*</SecondaryButton>*/}
    </Modal>
  );
};

DeclineBookingModal.defaultProps = {
  className: null,
  rootClassName: null,
  id: null,
  idDescriptionText: null,
  isOpen: false,
  isHighDeclineRate: false,
  onOkModal: Function.prototype,
  onCloseModal: Function.prototype,
};

DeclineBookingModal.propTypes = {
  className: string,
  rootClassName: string,
  id: string,
  idDescriptionText: string,
  isOpen: bool,
  isHighDeclineRate: bool,
  onOkModal: func,
  onCloseModal: func,
  intl: intlShape.isRequired,
};

export default injectIntl(DeclineBookingModal);
